export default __webpack_public_path__ + "static/media/IMG_3638.efec8282.JPG";